// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"57":"index","389":"calendar-entries-index","647":"contact-details-index"}[chunkId] + "." + {"57":"2d7609b1","389":"63cbe556","647":"54a0a961"}[chunkId] + ".css";
};